<template>
  <div
    class="active-filters"
    v-if="activeFilters.length"
  >
    <span
      v-for="activeFilter in activeFilters"
      :key="`${activeFilter.name}-${activeFilter.value}`"
      class="active-filters__filter | tag tag--button"
    >
      {{ activeFilter.label }}
      <span
        class="tag__button tag__button--icon_close"
        @click="removeFilterClickHandler(activeFilter.name, activeFilter.value)"
        :aria-label="$t('global.remove.filter.aria.label', [activeFilter.name + ' ' + activeFilter.value])"
        role="button"
        tabindex="0"
        @keydown="handleKeyDown"
      />
    </span>
    <span
      class="active-filters__remove-all | tag tag--button-left"
      @click="removeAllClickHandler"
      role="button"
      :aria-label="$t('global.remove.all.filters.aria.label')"
      tabindex="0"
      @keydown="handleKeyDown"
    >
      <span
        class="tag__button tag__button--icon_close"
      />
      {{ $t('productlist.filter.list.reset.button') }}
    </span>
  </div>
</template>

<script>
  import plpStateComputedMixin from '../../utilities/vueMixins/plpStateComputedMixin/plpStateComputedMixin.js';

  export default {
    mixins: [
      plpStateComputedMixin,
    ],
    props:
      {
        updatePageOnChange: {
          type: Boolean,
          default:
            true
        }
      }
    ,
    methods: {
      removeFilterClickHandler(name, value) {
        this.$store.dispatch('productsListPage/removeActiveFilterOption', {
          name: name,
          value: value,
          updatePageOnChange: this.updatePageOnChange
        });
      },
      removeAllClickHandler() {
        this.$store.dispatch('productsListPage/removeAllActiveFilterOptions', {
          updatePageOnChange: this.updatePageOnChange
        });
      },
      handleKeyDown(event) {
        if (event.key === 'Enter' || event.code === 'Space') {
          event.preventDefault();
          event.target.click();
        }
      }
    }
  }
  ;

</script>
